import { useCallback } from 'react';
import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation newNpoAnswer (
    $questionId: Int!,
    $reportId: Int,
    $text: String,
    $answerId: Int,
    $answerErrors: Int,
    $answerWarnings: Int,
    $timeOnQuestions: Int
    $date1: Date,
    $date2: Date,
    $questionText: String,
    $investmentId: Int,
    $programId: Int,
    $orgYear: Int,
    $resourceId: Int
  ) {
    newNpoAnswer (
    questionId: $questionId,
    reportId: $reportId,
    text: $text,
    answerId: $answerId,
    answerErrors: $answerErrors,
    answerWarnings: $answerWarnings,
    timeOnQuestions: $timeOnQuestions,
    date1: $date1,
    date2: $date2,
    questionText: $questionText,
    investmentId: $investmentId,
    programId: $programId,
    orgYear: $orgYear,
    resourceId: $resourceId
  ) {
      id
      success
      nextQuestion
    }
  }
`;

export const queryInvestment = gql`
  mutation newNpoAnswer (
    $investmentId: Int,
    $questionId: Int!,
    $text: String,
    $answerId: Int,
    $answerErrors: Int,
    $answerWarnings: Int,
    $timeOnQuestions: Int
    $date1: Date,
    $date2: Date,
    $questionText: String,
    $programId: Int,
    $orgYear: Int,
    $resourceId: Int
  ) {
    newNpoAnswer (
    investmentId: $investmentId,
    questionId: $questionId,
    text: $text,
    answerId: $answerId,
    answerErrors: $answerErrors,
    answerWarnings: $answerWarnings,
    timeOnQuestions: $timeOnQuestions,
    date1: $date1,
    date2: $date2,
    questionText: $questionText,
    programId: $programId,
    orgYear: $orgYear,
    resourceId: $resourceId
  ) {
      id
      success
      nextQuestion
    }
  }
`;

export function useNewNpoAnswer() {
  const { data, isLoading, mutate } = useMutation();
  const run = useCallback((variables, onFinish) => {
    mutate(variables?.reportId ? query : queryInvestment, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newNpoAnswer.id, response.newNpoAnswer.nextQuestion);
      }
    });
  }, []);
  return { data, isLoading, run };
}
